import React, { Suspense, lazy } from "react";
// Import route en useLocation hook
import { Routes, Route } from "react-router-dom";

// Routes are code-split so a visitor landing on the homepage does not download
// the portfolio, photobook and admin pages along with it.
const Home = lazy(() => import("../pages/Home"));
const About = lazy(() => import("../pages/About"));
const Portfolio = lazy(() => import("../pages/Portfolio"));
const Products = lazy(() => import("../pages/Products"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));
const Philosophy = lazy(() => import("../pages/Philosophy"));
const PhotoBook = lazy(() => import("../pages/PhotoBook"));
const ReviewSystem = lazy(() => import("../pages/Review"));
const AdminReviewPage = lazy(() => import("../pages/admin"));

// Reserves roughly a screen of height so the header and footer do not jump
// together while a route chunk is in flight.
const RouteFallback = () => <div className="min-h-[60vh]" />;

const AnimRoutes = () => {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/products" element={<Products />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/philosophy" element={<Philosophy />} />
        <Route path="/photo-book" element={<PhotoBook />} />
        <Route path="/review" element={<ReviewSystem />} />
        <Route path="/admin" element={<AdminReviewPage />} />
      </Routes>
    </Suspense>
  );
};

export default AnimRoutes;
